import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#0B0B0D] flex flex-col">
      <SEO
        title="Terms of Service | Subsurface"
        description="Terms governing use of Subsurface diagnostics, reports and consultancy services."
        path="/terms"
      />
      <Navigation />

      <div className="flex-1 pt-32 pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold font-display mb-8">Terms of Service</h1>
          
          <div className="glass-card p-8 rounded-lg space-y-6 text-[#A0A0A0]">
            <p className="text-sm">Last updated: January 2026</p>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-3">1. Service Description</h2>
              <p className="leading-relaxed">Subsurface provides trust and risk intelligence services, including diagnostic scans, expert analysis, and consulting services.</p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-3">2. Discovery Scans</h2>
              <p className="leading-relaxed">Our automated scans provide surface-level discovery. Full Trust & Revenue Integrity Reviews are separate consulting engagements.</p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-3">3. Limitation of Liability</h2>
              <p className="leading-relaxed">Subsurface diagnostic outputs are advisory in nature. We are not liable for business decisions made based on diagnostic results.</p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-3">4. Intellectual Property</h2>
              <p className="leading-relaxed">All diagnostic frameworks, methodologies, and reports remain the property of Subsurface.</p>
            </section>

            <section>
              <h2 className="text-2xl font-display font-semibold text-white mb-3">5. Contact</h2>
              <p className="leading-relaxed">For terms inquiries: <a href="mailto:hello@subsurfaceconsulting.co" className="text-[#FF6A00] hover:text-[#FF6A00]/80">hello@subsurfaceconsulting.co</a></p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsPage;
